import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Auth.css';

export function Login() {
  const { signIn } = useAuth();
  const navigate   = useNavigate();
  const [form, setForm]     = useState({ email: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const upd = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    const { error } = await signIn(form);
    if (error) { setError(error.message); setLoading(false); }
    else navigate('/');
  };

  return (
    <div className="auth-page page-enter">
      <div className="auth-card">
        <span className="auth-wordmark">
          <span className="auth-wordmark-e">ELEC</span>
          <span className="auth-wordmark-d">TRADEZ</span>
        </span>
        <h1>Welcome back</h1>
        <p className="auth-sub">Sign in to your account</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input name="email" type="email" className="form-input" placeholder="you@example.com" value={form.email} onChange={upd} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input name="password" type="password" className="form-input" placeholder="••••••••" value={form.password} onChange={upd} required />
          </div>
          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="auth-footer">No account? <Link to="/signup">Sign up free</Link></p>
      </div>
    </div>
  );
}

export function Signup() {
  const { signUp } = useAuth();
  const navigate   = useNavigate();
  const [form, setForm]         = useState({ email:'', password:'', username:'', fullName:'' });
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false); // NEW

  const upd = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault(); setError('');
    if (form.password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (!agreedToTerms) { setError('You must agree to the Terms of Service and Privacy Policy.'); return; } // NEW
    setLoading(true);
    const { error } = await signUp(form);
    if (error) { setError(error.message); setLoading(false); }
    else setSuccess(true);
  };

  if (success) return (
    <div className="auth-page page-enter">
      <div className="auth-card">
        <span className="auth-wordmark"><span className="auth-wordmark-e">ELEC</span><span className="auth-wordmark-d">TRADEZ</span></span>
        <h1>Check your email</h1>
        <p className="auth-sub">We sent a confirmation link to <strong>{form.email}</strong>. Click it to activate your account.</p>
        <Link to="/login" className="btn btn-primary auth-submit">Go to Login</Link>
      </div>
    </div>
  );

  return (
    <div className="auth-page page-enter">
      <div className="auth-card">
        <span className="auth-wordmark"><span className="auth-wordmark-e">ELEC</span><span className="auth-wordmark-d">TRADEZ</span></span>
        <h1>Create account</h1>
        <p className="auth-sub">Join the e-moto marketplace</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row-auth">
            <div className="form-group">
              <label className="form-label">Username *</label>
              <input name="username" className="form-input" placeholder="ridername" value={form.username} onChange={upd} required minLength={3} />
            </div>
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input name="fullName" className="form-input" placeholder="Optional" value={form.fullName} onChange={upd} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Email *</label>
            <input name="email" type="email" className="form-input" placeholder="you@example.com" value={form.email} onChange={upd} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password *</label>
            <input name="password" type="password" className="form-input" placeholder="Min 6 characters" value={form.password} onChange={upd} required minLength={6} />
          </div>

          {/* Terms checkbox - NEW */}
          <div className="terms-check">
            <label className="terms-label">
              <input
                type="checkbox"
                checked={agreedToTerms}
                onChange={e => setAgreedToTerms(e.target.checked)}
              />
              <span>
                I agree to the{' '}
                <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</Link>
                {' '}and{' '}
                <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
              </span>
            </label>
          </div>

          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p className="auth-footer">Already have an account? <Link to="/login">Sign in</Link></p>
      </div>
    </div>
  );
}
